import styled from 'styled-components';

export const Heading = styled.h4`
  margin: 15px 0;
  color: ${({ theme }) => theme.title};
`;
